var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cat_banner",staticClass:"cloudpictureanner"},[_c('transition',{attrs:{"name":"fade-in-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.active),expression:"this.active"}],staticClass:"context"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }